import React from "react";
import "./post-description.style.scss";
import { Redirect, Route, useHistory } from "react-router";
import { Link ,withRouter} from "react-router-dom";
import { getInstituteJobDetailsById } from "../../../../../APIs/GetAPIs";

 const PostDescription=({ initialRun, setRouteTitle })=> {
  const history = useHistory();
  let job_id=localStorage.getItem("job_id")
  const [jobDetails, setJobDetails] = React.useState("");
  const [bar, setBar] = React.useState(true);
  React.useEffect(() => {
    initialRun();
    setRouteTitle("PRT Science teacher");
  }, []);

  React.useEffect(()=>{
    const getData=async()=>{
    let ress=await getInstituteJobDetailsById(job_id)
setJobDetails(ress?.data?.data)
    }
    getData()
  },[job_id])
console.log('jobDetails',jobDetails)
{/* <h5 className="job-title">{job?.job_title}</h5>
<p className="institute-name">{job?.institution_name}</p>
<div className="jpcm-info">
  <span>
    <img src={Images.blueBook} />
    {job?.job_curiculum}
  </span>
  <span>
    <img src={Images.groupLogo} />
    {job?.job_class}
  </span>
  <span>
    <img src={Images.suitcaseLogo} />
    {job?.job_type}
  </span>
  <span>
    <img src={Images.manWIthStars} />
    {job?.job_experience} exp
  </span>
  <span>
    <img src={Images.moneyLogo} />
    {job?.job_salary_range}
  </span>
</div> */}

// about_institution: true
// bed_required: false
// createdAt: "2021-10-07T10:39:41.168Z"
// institute_location: true
// institution_id: "615d4d61fd21ddf2c8de355c"
// institution_logo: true
// institution_name: true
// isDraft: false
// job_class: "class 8-10"
// job_college_preference: ['']
// job_curiculum: "cbse"
// job_description: "edwsgefdsgdf"
// job_experience: "4-6yrs"
// job_gender_preference: "none"
// job_id: ""
// job_key_skill: ['']
// job_language_preference: ['']
// job_martinal_status: "unmarried"
// job_outstation_candidate: true
// job_perk_provided: ['']
// job_publish_status: false
// job_role: "teacher"
// job_salary_range: ""
// job_subject: "maths"
// job_title: "test"
// job_type: "Full Time"
// job_vacancies: ""
// salary: true
// status: "active"
// updatedAt: "2021-10-07T10:39:41.168Z"
// __v: 0
// _id: "615ece6d0d2870627d8effd2"
// [[Prototype]]: Ob
let chars = {'[':'',']':'',',':']'};

  return (
    <div className="jdm-body">
      <section className="jdm-left">
        <div className="jdml-info">
          <div>
            <h6>{jobDetails?.job_experience}</h6>
            <p>Experience</p>
          </div>

          <div>
            <h6>{jobDetails?.job_class}</h6>
            <p>Class</p>
          </div>
          <div>
            <h6>{jobDetails?.job_curiculum}</h6>
            <p>curriculum</p>
          </div>
          <div>
            <h6>{jobDetails?.job_salary_range!==undefined&& jobDetails.job_salary_range.replace(/[^a-zA-Z0-9]/g,'-').substring(1,jobDetails.job_salary_range.replace(/[^a-zA-Z0-9]/g,'-')
.length-1)

}</h6>
            <p>Salary Offered</p>
          </div>
          <div>
            <h6>B Ed</h6>
            <p>Qualification Required</p>
          </div>
        </div>
        <div className="job-describe">
          <p>
           {jobDetails?.job_description}
          </p>
          <p>
            High School English Teachers teach students about literature, essay
            composition, and how to use language in powerful ways. Teaching
            classic novels, plays, and poetry to students and helping them
            analyze a variety of texts. High School English Teachers may also
            prepare students to write their college essays. The High School
            English Teacher’s responsibilities include planning lessons and
            developing curricula, reading and understanding all prescribed
            texts, offering academic support to students, and ensuring a safe
            learning environment. You should also be able to juggle multiple
            deadlines, liaise with a number of professionals, and respond well
            to criticism.
          </p>
          <ul>
            <li>
              Reading all prescribed novels, poetry, and additional resources to
              gain a thorough understanding of them before developing lesson
              plans and curricula.
            </li>
            <li>
              Collaborating with other English department staff to develop
              lesson plans, teaching strategies, and interventions.
            </li>
            <li>Preparing students for formal and informal assessments.</li>
            <li>
              Grading tests, pop quizzes, assignments, exams, and other
              assessments, and communicating with parents, students, teachers,
              and counselors regarding underperformance and other concer
            </li>
            <li>
              Organizing guest speakers, literary events, and field trips.
            </li>
            <li>
              Keeping abreast of current events and incorporating these events
              and themes into lessons to make them more relevant to students.
            </li>
            <li>
              Ensuring all curriculum, school, and state requirements are met.
            </li>
            <li>
              Assessing student needs and providing support or extra resources
              to struggling students as well as exceptional achievers.
            </li>
            <li>
              Using technology to improve lesson delivery and recordkeeping.
            </li>
            <li>
              Expanding teacher networks and participating in workshops,
              lectures, and other learning opportunities
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
export default PostDescription;